import gql from 'graphql-tag';

import type { ProjectSectionSummary } from 'src/data/project';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_SECTION } from './schema';

const QUERY = gql`
  query ProjectSections($projectId: Int!) {
    project(id: $projectId) {
      sections {
        ...ProjectSectionFields
      }
    }
  }
  ${FRAGMENT_PROJECT_SECTION}
`;

export const queryProjectSections = async (projectId: number): Promise<ProjectSectionSummary[]> => {
  const result = await executeGqlQuery({ query: QUERY, variables: { projectId } });
  throwIfResultHasErrors(result);

  const project = getSingleProp<{ sections?: ProjectSectionSummary[] | null }>(result.data);
  return project?.sections ?? [];
};
